/* istanbul ignore file */
import { CreateForm } from 'framework/form';
import { OneStopPageLayout } from 'domain/shared/oneStop';
import useBudgetReallocationService from '../budgetReallocationService';
import BudgetReallocationForm from '../BudgetReallocationForm';

interface OneStopBudgetReallocationProps {
  openModal: (message: string) => void;
}

const OneStopBudgetReallocation = ({ openModal }: OneStopBudgetReallocationProps) => {
  const { getOneStopValidationSchema, createBudgetReallocation } = useBudgetReallocationService();

  return (
    <CreateForm
      submitFormFunc={createBudgetReallocation}
      afterSubmit={{
        execute: response => {
          openModal(response.message);
        },
      }}
      getValidationSchemaFunc={getOneStopValidationSchema}
    >
      <OneStopPageLayout>
        <BudgetReallocationForm />
      </OneStopPageLayout>
    </CreateForm>
  );
};

export default OneStopBudgetReallocation;
